<template>
	<div
		class="timeline-block w-full flex flex-col xl:flex-row å xl:gap-[64px] md:px-[32px] p-[24px] xl:px-[64px] md:py-[32px] xl:py-[64px]"
		data-animate="true"
	>
		<div class="flex flex-col gap-[16px] lg:gap-[24px] justify-center">
			<div
				class="overflow-hidden text-blue-500 text-ellipsis text-sm font-extrabold"
			>
				{{ label }}
			</div>
			<h3
				class="text-left text-white leading-tight text-[32px] md:text-[54px] font-medium"
			>
				{{ title }}
			</h3>
			<p class="text-slate-300 leading-relaxed text-lg">
				{{ description }}
			</p>
		</div>
		<img
			loading="lazy"
			:src="image"
			class="w-full max-w-[520px] md:max-w-full lg:min-w-[520px]"
		/>
	</div>
</template>

<script setup>
defineProps(["label", "title", "description", "image"]);
</script>
